/*
 * @Author: your name
 * @Date: 2021-02-07 13:40:50
 * @LastEditTime: 2021-12-02 15:59:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue3-element-admin\src\api\modules\system.js
 */
// const Mock = require("mockjs"); //引入
import config from "../config"

export default {
    userMenuList: {
        url: config.base_url + "menu/userMenuList",
        type: "post",
    },
    roleMenuList: {
        url: config.base_url + "menu/role-assign-menu/list",
        type: "get",
    },
    menuIdListByRoleId: {
        url: config.base_url + "menu/role-menu/{roleId}",
        type: "get",
    },
    phoneLogin: {
        url: config.base_url + "user/phone_login",
        type: "post",
    },
    login: {
        url: config.base_url + "user/login",
        type: "post",
    },
    userList: {
        url: config.base_url + "user/list/{limit}/{page}",
        type: "get",
    },
    userSelectOption: {
        url: config.base_url + "user/selectOption",
        type: "get",
    },
    roleList: {
        url: config.base_url + "sys_role/list",
        type: "get",
    },
    addUser: {
        url: config.base_url + "user/add",
        type: "post",
    },
    editUser: {
        url: config.base_url + "user/update",
        type: "post",
    },
    deleteUser: {
        url: config.base_url + "user/delete",
        type: "get",
    },
    organList: {
        url: config.base_url + "farm/list",
        type: "post",
    },
    getCfg: {
        url: config.base_url + "cfg/get?key=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9",
        type: "post",
    },
    testJs:{
        url: config.base_url + "script/test",
        type: "post",
    }
};
